import React from 'react';

import useLocalization from '../../localization/useLocalization';
import { Wrapper, ResultInfoWrapper } from './styled/CallResultPopupStyled';
import CloseButton from './CloseButton/CallResultPopupCloseButton';
import CallInfo from './CallInfo/CallResultPopupCallInfo';
import Emoji from './Emoji/CallResultPopupEmoji';

interface CallResultPopupProps {
    spottedPhrasesScore?: number;
    totalPhrasesScore?: number;
    bonusScore?: number;
    isLastCallResult: boolean;
    isVisible: boolean;
    onClose: () => void;
    localization: { getText: (key: string, options?: Record<string, string | number | boolean | null | undefined>) => string };
}

function CallResultPopupView(props: CallResultPopupProps) {
    const { spottedPhrasesScore, totalPhrasesScore, bonusScore, localization, isLastCallResult, isVisible, onClose } = props;

    return (
        <Wrapper $visible={isVisible}>
            <CloseButton onClose={onClose} />
            <ResultInfoWrapper>
                <CallInfo
                    spottedPhrasesScore={spottedPhrasesScore}
                    totalPhrasesScore={totalPhrasesScore}
                    isLastCallResult={isLastCallResult}
                    localization={localization}
                    bonusScore={bonusScore}
                />
                <Emoji visible={isVisible} spottedPhrasesScore={spottedPhrasesScore} totalPhrasesScore={totalPhrasesScore} />
            </ResultInfoWrapper>
        </Wrapper>
    );
}

CallResultPopupView.defaultProps = {
    spottedPhrasesScore: 0,
    totalPhrasesScore: 0,
    bonusScore: 0
};

export const PureCallResultPopup = CallResultPopupView;

function CallResultPopup(props: Omit<CallResultPopupProps, 'localization'>) {
    const localization = useLocalization();
    return <CallResultPopupView {...props} localization={localization} />;
}

export default CallResultPopup;
